import { Suspense, lazy } from "react";
const Toaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const Sonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Index from "./pages/Index";
import Article from "./pages/Article";
import Noticias from "./pages/Noticias";
import NewsDetail from "./pages/NewsDetail";
import Cursos from "./pages/Cursos";
import Ferramentas from "./pages/Ferramentas";
import Dicionario from "./pages/Dicionario";

// Lazy load low-traffic pages
const Sobre = lazy(() => import("./pages/Sobre"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Suspense><Toaster /></Suspense>
        <Suspense><Sonner /></Suspense>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/noticias/:id" element={<NewsDetail />} />
            <Route path="/article/:id" element={<Article />} />
            <Route path="/cursos" element={<Cursos />} />
            <Route path="/ferramentas" element={<Ferramentas />} />
            <Route path="/dicionario" element={<Dicionario />} />
            <Route path="/sobre" element={<Suspense><Sobre /></Suspense>} />
            <Route path="/privacy" element={<Suspense><Privacy /></Suspense>} />
            <Route path="/terms" element={<Suspense><Terms /></Suspense>} />
            <Route path="*" element={<Suspense><NotFound /></Suspense>} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
